<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" routerDirection="root" (click)="returnToAuthLogin()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title style="font-size: 13px; margin-left: 10px; text-align: left;">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false">
  <div class="default-content">
    <!--<img class="center-block full-logo" logo />-->
    <img class="center-block full-logo" [src]="logo" />

    <br>

      @if (!emailCode) {
        <auth-forgot-password-form (onSubmit)="onPasswordForgotFormSubmited($event)">
        </auth-forgot-password-form>
      }

      @if (emailCode) {
        <div class="step-2">
          <!--
          <p class="text-center" color="primary" [translateParams]="{ email: forgotPasswordForm.email }"
            [translate]="'EmailVerification.YouHaveReceivedACodeMessage'">
          </p>
          -->
          <p class="text-center">{{ 'ForgotPassword.EmailSent' | translate: { email: forgotPasswordForm.email } }}</p>
          <p class="text-center"><a class="notice-text" (click)="notReceivedAnyCode()">{{ 'EmailVerification.NotReceivedMessage' | translate }}</a></p>
          <auth-new-password-form  (onSubmit)="onChangePasswordForgotFormSubmited($event)">
          </auth-new-password-form>
        </div>
      }
    </div>
  </ion-content>